import React from 'react';
export const TransitionHookSection = () => {
  return <section className="bg-familia-section relative py-10 md:py-16 px-4 md:px-6 overflow-hidden" data-id="element-273">
      <div className="absolute inset-0 bg-gradient-to-r from-familia-bg/60 to-familia-section opacity-60 pointer-events-none" data-id="element-274" />
      <div className="relative z-10 max-w-4xl mx-auto text-center w-[92%] md:w-full" data-id="element-275">
        <h2 className="text-[22px] sm:text-3xl md:text-5xl font-display font-bold mb-6 md:mb-8 leading-tight" data-id="element-276">
          El enemigo no es el cuidado: <br className="hidden md:block" data-id="element-277" />
          es la improvisación y la información dispersa.
        </h2>
        <div className="space-y-2 text-familia-gray text-[15px] md:text-xl max-w-2xl mx-auto" data-id="element-278">
          <p data-id="element-279">El problema no es que te falte amor, compromiso o voluntad.</p>
          <p data-id="element-280">
            El problema es intentar organizar el cuidado diario con información
            suelta y sin un sistema claro. Vitalidad 360™ reúne actividades,
            rutinas, registros y orientaciones prácticas en un solo lugar.
          </p>
          <p className="text-white font-bold" data-id="element-281">
            Así puedes comenzar con una opción adecuada cada día.
          </p>
          <p className="text-familia-cyan font-bold" data-id="element-282">
            Sin adivinar qué hacer ni buscar todo desde cero.
          </p>
        </div>
      </div>
    </section>;
};